export default __webpack_public_path__ + "graphics/menu.4ff33a53.svg";